import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux';
import { AppState } from '../../types/redux';
import { bankValidationReducer as bankValidation } from './bankValidationReducer';
import { contentfulReducer as contentful } from './contentful/contentfulReducer';
import { contractPricesReducer as contractPrices } from './contractPricesReducer';
import { contractReducer as contract } from './contractReducer';
import { contractFinishReducer as contractFinish } from './contractFinishByEmailReducer';
import { contractSignatureReducer as contractSignature} from './contractSignatureReducer';
import { contractWizardReducer as contractWizard } from './contractWizard/contractWizardReducer';
import { customizingReducer as customizing } from './customizingReducer';
import { userReducer as user } from './mobiversReducer';
import { notificationReducer as notification } from './notificationReducer';
import { collectedStateReducer as collectedState } from "../reducers/collectedStateReducer";

export const createRootReducer = (history: History) =>
	combineReducers<AppState>({
		router: connectRouter(history),
		user,
		contract,
		contractWizard,
		contractPrices,
		bankValidation,
		contractSignature,
		contractFinish,
		collectedState,
		contentful,
		notification,
		customizing,
	});
